jQuery(window).load(function () {
	jQuery('.fa-search').click(function(e){
		e.stopPropagation();
	});
	jQuery('#menu-search').click(function(e){
		e.stopPropagation();
	});
	jQuery('.fa-search').click(function(e) {
		jQuery('#menu-search').toggle();
	});
	jQuery(".issue-understory-img").mouseenter(function() {
		jQuery(this).children(".blog-overlay").fadeIn();
	})
	.mouseleave(function() {
	    jQuery(this).children(".blog-overlay").fadeOut();
	});
	jQuery(".issue-understory-img").focusin(function() {
		jQuery(this).children(".blog-overlay").fadeIn();
	})
	.focusout(function() {
	    jQuery(this).children(".blog-overlay").fadeOut();
	});
	
	jQuery(".content-image-wrap .image").mouseenter(function() {
		jQuery(this).children(".blog-overlay").fadeIn();
	})
	.mouseleave(function() {
	    jQuery(this).children(".blog-overlay").fadeOut();
	});
	jQuery(".content-image-wrap .image").focusin(function() {
		jQuery(this).children(".blog-overlay").fadeIn();
	})
	.focusout(function() {
	    jQuery(this).children(".blog-overlay").fadeOut();
	});
	jQuery('#ss-floating-bar').css('opacity', '0');

	jQuery('.heateor_sss_vertical_sharing').css('opacity', '0');

	jQuery('a.revel-button').click( function(e){
		if (jQuery(window).width() > 800) { 
			e.preventDefault();
			var url = jQuery(this).attr("href");
			jQuery('.page-video-test-page #responsive-iframe iframe').attr('src', url);
			jQuery('.page-video-test-page #iframe-container').css('display','block');
		}
	});
	
	jQuery('.page-video-test-page #iframe-container').click( function(){
		jQuery('.page-video-test-page #iframe-container').css('display','none');
		jQuery('.page-video-test-page #responsive-iframe iframe').attr('src', '');
	});
	

	/* widow fix */
		
	jQuery(".understory-featured-image h1.block-headline").each(function() {
	  var wordArray = jQuery(this).text().split(" ");
	  if (wordArray.length > 1) {
	    wordArray[wordArray.length-2] += "&nbsp;" + wordArray[wordArray.length-1];
	    wordArray.pop();
	    jQuery(this).html(wordArray.join(" "));
	  }
	});
	// I am leaving this easter egg for you all to find and be slightly annoyed by -- minjae you can delete this little snippet and the html from footer.php and it will go away. I made this panther wearing a mask to appear when you hovered over our covid details now it appears when you hover over our tax details sshhhhh
	jQuery('.site-footer .tax-details').hover(function(){
		jQuery('#eegg').toggle("slow");
	});
	
	jQuery("ul.green-arrow li").prepend( "<i class=\"fas fa-arrow-circle-right\"></i>" );

	jQuery(".keyfindings li").prepend( "<i class=\"fas fa-arrow-circle-right\"></i>" );


});
jQuery(document).on('click','.navbar-collapse',function(e) {
    if( jQuery(e.target).is('a') ) {
        jQuery(this).collapse('hide');
    }
});

jQuery(document).scroll(function() {
  var y = jQuery(this).scrollTop();
  if (y > 550) {
    jQuery('div.heateor_sss_bottom_sharing').css('opacity', '1');
  } else {
    jQuery('div.heateor_sss_bottom_sharing').css('opacity', '0');
  }
});

jQuery(document).scroll(function() {
	var y = jQuery(this).scrollTop();
	if (y > 700) {;
	  jQuery('#ways-menu').css('opacity', '1');
	} else {
	  jQuery('#ways-menu').css('opacity', '0');
	}
  });